import React from "react";
import "../../Assets/Styles/pages/terms.scss";
import { Row } from "react-bootstrap";

const Terms: React.FC = () => {
  const termsContent = `
    <!DOCTYPE html>

    <body>
    
    <p>By signing up for a user account with the eZy Watermark app, you acknowledge that you have read, understood and agreed to be bound by these terms and conditions. The material provided through the App protected by law, including, but not limited to, United States copyright law and international treaties.</p>
    
    <h2>User account</h2>
    
    <p>In order to use the service, a user must sign up for an account, either through the Web or Mobile app.</p>
    
    <h2>Privacy policy</h2>
    
    <p>Use of the service and/or the App or Site also falls under the terms of our <a href="/privacy-policy">Privacy Policy</a>.</p>
    
    <h2>Community guidelines</h2>
    
    <p>The eZy Watermark app/service can be used individually, or with others in the context of an online community. We take this community very seriously, and reserve the right to protect legitimate users from illegimate users or purposes contrary to the intentions of the app. As an example, we reserve the right in our sole discretion to block users or cancel their accounts if they post spam or abuse other users. The eZy Watermark app and service are intended to only be used for adding Watermark on photos and videos. Using the app for any other purposes may result in the discontinuation of your eZy Watermark account, with or without notice.</p>
    
    <h2>Subscriptions & Billing</h2>
    <p>We offer monthly and yearly subscription plans that provide access to premium watermarking features. By subscribing, you agree to recurring billing on a monthly or yearly cycle, which will automatically renew unless canceled. You can cancel your subscription at any time through your account settings or mobile store settings.</p>

    <h2>Refund policy</h2>
    <p>Except as required by law, all subscription fees are non-refundable. For detailed information on cancellations and refund eligibility, please refer to our <a href="/refund-policy">Refund Policy</a>.</p>
    
    <h2>Revisions to this agreement</h2>
    
    <p>We may revise this Agreement at any time without notice by updating this posting. By using this App you agree to be bound by any such revisions and should therefore periodically visit this Site and page to determine the then current terms and conditions of use to which you are bound.</p>
    
    <h2>Your acceptance of these terms</h2>
    
    <p>By using the App, you signify your acceptance of these terms of service and privacy policy. If you do not agree to these terms, you may not sign up for a user account. Your continued use of the App following the posting of changes to these terms will be deemed your acceptance of those changes.</p>
    
    <h2>Contacting us</h2>
    
    <p>If you have any questions about these terms, the practices of this Site or App, or your dealings with this Site or App, please contact us at:</p>
    
    <p>eZy Watermark<br>
      Ground Floor, Plot # 3-4,<br/>
      I&T Centre,G-8/4,<br/>
     Islamabad , Pakistan<br>46000 <br>
    <a href="mailto:support@ezywatermark.com">support@ezywatermark.com</a></p>
    
    <h2>Representations and warranties</h2>
    
    <p><i>By You.</i> You represent and warrant to us that: (a) you are eligible to register and use the Service; (b) the name identified by you when you registered is your own true name;</p>
    
    <p><i>Disclaimer.</i> The Site, App and service are provided on an "as is" basis. To the fullest extent permitted by applicable law, we make no representations or warranties of any kind, express or implied, regarding the Site, App or service.</p>
    
    <h2>Limitation on liability</h2>
    
    <p>To the extent permitted by applicable law, we and our employees, directors, agents and representatives will not be liable for any indirect, incidental, punitive, or consequential damages arising out of or in connection with this agreement, the Site, App, or the service (including the inability to use the service), any application using our service, or any services or goods purchased or transactions entered into through the service.</p>
    
    <p>The laws of certain states or other jurisdictions do not allow limitations on implied warranties, or the exclusion or limitation of certain damages. If these laws apply, some or all of the above disclaimers, exclusions, or limitations may not apply to you, and you may have rights in addition to those contained in this Agreement. Our liability is limited to the greatest extent permitted by law.</p>
    
    <h6>
        Written/Updated: April 23, 2019
    </h6>
    
    
    </body></html>`;

  return (
    <Row className="m-0 w-100 d-flex justify-content-center prouctSansLight text_16">
      <div
        className="w-75 text-start my-5 px-5"
        dangerouslySetInnerHTML={{ __html: termsContent }}
      />
    </Row>
  );
};

export default Terms;
